import React from 'react';

import cms from 'apis/cms';
// import { objFake } from './objFake';
import { CustomTagProps } from 'types/CustomTagProps';
import { PaginationProps } from 'types/PaginationProps';

export async function getTags(
  setTags: React.Dispatch<React.SetStateAction<CustomTagProps[]>>,
  setPagesData: React.Dispatch<React.SetStateAction<PaginationProps>>,
  page = 1,
  limit = 10,
) {
  await cms.rest
    .get(`promotional-tags?limit=${limit}&page=${page}&visibleOnly=false`)
    .then((res: any) => {
      if (res.data && res.data.data.length > 0) {
        setTags(res.data.data);

        setPagesData({
          limit: res.data.limit,
          page: res.data.page,
          total: res.data.total,
          totalPages: res.data.totalPages,
        });
      } else {
        setTags([]);
        setPagesData({
          limit: 10,
          page: 1,
          total: 0,
          totalPages: 0,
        });
      }
    })
    .catch(error => {
      console.log('error: ', error);
    });
}
